let Environment = {
  // round 1
  dop1: "0xF49e4197324059e819690a0588dec5AB25d3985C",
  dop: "0xec135D3aEe90a5119681Ce4317BA42281edA7b49",
  insurance: "0x21DA8afc2b24d8a9A126638b5f142Bf77a19CB59",
  dopDynamic: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
};

export default Environment;
